import { render, staticRenderFns } from "./template.html?vue&type=template&id=25735b5a&scoped=true&"
import script from "./TrailsExam.vue?vue&type=script&lang=js&"
export * from "./TrailsExam.vue?vue&type=script&lang=js&"
import style0 from "./TrailsExam.vue?vue&type=style&index=0&id=25735b5a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25735b5a",
  null
  
)

export default component.exports